import { NotificationParser } from "@app/wapps/notification/notification.parser";
import { Notification } from "@app/wapps/notification/notification.model";
import { Injector } from "@angular/core";
import { format } from "date-fns";
import { NOTIFICATION_TIME_FORMAT, PT_BR_DATE_LOCALE } from "@ui/date-formats";

export class AppointmentNotificationParser extends NotificationParser {
    static Type = "Wapps.Health.Appointment.Notifications.AppointmentNotificationData";

    static SilentType = "Wapps.Health.Appointment.Notifications.AppointmentSilentNotificationData";

    constructor(injector: Injector) {
        super(injector);
    }

    parse(userNotification): Notification {
        let id = userNotification.id;
        let icon = "today";
        let data: any = userNotification.notification.data;
        if (!data.date) {
            data = data.properties;
        }
        let title = this.l(`Health.Appointment.Status.${data.status}.Notification.Title`);
        const subtitle = format(new Date(userNotification.notification.creationTime), NOTIFICATION_TIME_FORMAT, {
            locale: PT_BR_DATE_LOCALE,
        });
        return new Notification(id, icon, title, subtitle, userNotification);
    }

    open(notification: Notification) {
        let data: any = notification.userNotification.notification.data;
        if (!data.date) {
            data = data.properties;
        }
        let id = data.id;
        let queryParams = {
            id: id,
            date: new Date(data.date).toUTCString(),
        };
        this.router
            .navigate(["/calendar"], {
                queryParams,
            })
            .then();
    }
}
